import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';

const stringToColor=(string)=> {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.substring(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

const stringAvatar = (name)=> {
  let xx = name.split(' ')
  let avt = '@@'
  if (xx.length===1)
  {
    avt = xx[0][0]
    //if(xx[0].length>1)  avt = avt+xx[0][1]
  }
  else if (xx.length>1)
  {
    avt = xx[0][0]+xx[1][0]
  }

  return {
    sx: {
      bgcolor: 'white',
      color:'#2244dd',
      
      width:32, height:32,
      mr:{xs:1,lg:0},
    },
    //children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    children : `${avt}`
  };
}

export default function UserAvatars({name}) {
  return (
      <Avatar {...stringAvatar(name.toUpperCase()+" "+name.toUpperCase())} />
          
        );
}